export class ChannelTaskType {
    public ChannelId!: string;
    public TaskTypeId!: number;
    public IsDefault!: string;
}
